"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_pfeil_ost = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_pfeil_ost = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACLSURBVFhH7ZSxDYAwEANDxwiUlJSswiZswgiMAR2jsAYd2IRvEBINfATySad8Klt6JUEI8UdamMfRnx6ucIDuJQo4QxZIVqKEKkFUwrgtkR2n0cE6jo/B11HFcWeEDVz224kJWts35X9xiUcBroSrcYH75t4VrnAXkoYThjE0SbjBUP4lScKF+CIhbOLQaoYJgFsuAAAAAElFTkSuQmCC",
    iconSize: [32, 32],
});
